import { toastError } from "../helpers/methods";
import { SENDBIRD_INFO } from "../helpers/constant";
import { updateChatAssignment } from "./updateChatAssignment";
export const assignToMe = async (
    item,
    channel,
    loggedUserId,
    userInfo,
    status,
    dispatch,
    cb 
) => {
  const channelUrl = item?.channelUrl || item?.url;

  if (!channelUrl) return;
  try {
    await channel.unhide();
    const patient = channel.members.filter(
      (x) =>  x.userId.startsWith("PA")
    );
    const patientId=patient?patient[0].userId:null
    const unHideList = channel.members.filter(
      (x) => x.userId === loggedUserId || x.userId.startsWith("PA")
    );

    const dataParams = { data: JSON.stringify({ AssignedTo: loggedUserId }) };
    // 1️⃣ Update your backend
    updateChatAssignment(dispatch, {
      channelUrl,
      userInfo,
      patientId,
      status
    });
    
    // 2️⃣ Update channel metadata
    const updateRes = await fetch(
      `https://api-${SENDBIRD_INFO.appId}.sendbird.com/v3/group_channels/${channelUrl}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Api-Token": SENDBIRD_INFO.sendBirdToken,
        },
        body: JSON.stringify(dataParams),
      }
    );

    if (!updateRes.ok) throw new Error("Failed to update channel data");

    // 3️⃣ Hide all
    const hideAllRes = await fetch(
      `https://api-${SENDBIRD_INFO.appId}.sendbird.com/v3/group_channels/${channelUrl}/hide`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Api-Token": SENDBIRD_INFO.sendBirdToken,
        },
        body: JSON.stringify({
          should_hide_all: true,
          allow_auto_unhide: false,
        }),
      }
    );

    if (!hideAllRes.ok) throw new Error("Failed to hide all members");

    // 4️⃣ Unhide required users (1–2 max)
    for (const x of unHideList) {
      const unhideRes = await fetch(
        `https://api-${SENDBIRD_INFO.appId}.sendbird.com/v3/group_channels/${channelUrl}/hide`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Api-Token": SENDBIRD_INFO.sendBirdToken,
          },
          body: JSON.stringify({ user_id: x.userId }),
        }
      );

      if (!unhideRes.ok) console.warn(`Failed to unhide ${x.userId}`);
    }
    
    if (typeof cb === "function") cb();

  } catch (err) {
    console.error("Error in assignToMe:", err);
    toastError(err.message || "Something went wrong during chat reassignment");
  }
};
